import { type WritableDraft } from 'immer';
import { type Observable, of } from 'rxjs';

import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type EngineState } from '../../../+state/engine';
import {
  AbstractAiElementHandler,
  applyFieldSize,
  getElement,
  getInitialProps,
  patchFieldLabel,
  upsertElement,
} from '../../../ai';

import { type TextInputContext } from './text-input.definition';

export class TextInputElementHandler extends AbstractAiElementHandler<'textInput'> {
  readonly type = 'textInput';

  prepare(context: TextInputContext): Observable<TextInputContext> {
    this.resolveElementIcon(context.element);

    return of(context);
  }

  process(context: TextInputContext, draft: WritableDraft<EngineState>): void {
    let props: PartialPropsOf<'textInput'> = getInitialProps<'textInput'>(
      draft,
      context.element.id,
      {},
    );
    props = patchFieldLabel<'textInput'>(props, context.element);

    if (context.element.placeholder !== undefined) {
      props = applyPropsPatch<'textInput'>(props, {
        content: { input: { placeholder: context.element.placeholder } },
      });
    }

    if (context.element.isReadOnly !== undefined) {
      props = applyPropsPatch<'textInput'>(props, {
        content: { input: { readonly: context.element.isReadOnly } },
      });
    }

    const { elementId } = upsertElement(draft, context, props);
    applyFieldSize<'textInput'>(getElement(draft, elementId, 'textInput'), context.element);
  }
}
